import axios from 'axios';

import csrfTokenResolver from '@/shared/csrf-token';
import Toolbox from "@/shared/toolbox";

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.requestThrottled = function(method, url, data, config) {
    const instance = axios.create();

    instance.interceptors.response.use(response => response, async err => {
        const status = err?.response?.status;

        if (status === 429) {
            Toolbox.error('Too many requests. Please try again in a minute.');
        }

        return Promise.reject(err)
    });

    if (typeof config === 'undefined') {
        config = {};
    }

    config.method = method;
    config.url = url;
    config.data = data;

    return instance.request(config);
}

axios.getThrottled = function(url, config) {
    return axios.requestThrottled('GET', url, null, config);
}

axios.postThrottled = function(url, data, config) {
    return axios.requestThrottled('POST', url, data, config);
}

axios.deleteThrottled = function(url, data, config) {
    return axios.requestThrottled('DELETE', url, data, config);
}

axios.putThrottled = function(url, data, config) {
    return axios.requestThrottled('PUT', url, data, config);
}

axios.requestCsrf = function(method, url, data, config) {
    const instance = axios.create();

    instance.interceptors.request.use(async instanceConfig => {
        if (typeof instanceConfig === 'undefined') {
            instanceConfig = {};
        }

        if (typeof instanceConfig.headers === 'undefined') {
            instanceConfig.headers = {};
        }

        if (typeof instanceConfig.headers['X-CSRF-TOKEN'] === 'undefined') {
            const csrfToken = await csrfTokenResolver.resolve();

            console.info('Using CSRF token', csrfToken);

            instanceConfig.headers['X-CSRF-TOKEN'] = csrfToken;
        }

        return instanceConfig;
    }, (error) => {
        return Promise.reject(error);
    });

    instance.interceptors.response.use(response => response, async err => {
        const status = err?.response?.status;

        if (status === 419) {
            await csrfTokenResolver.refresh();

            return axios.requestCsrf(method, url, data, config);
        }

        return Promise.reject(err)
    });

    if (typeof config === 'undefined') {
        config = {};
    }

    config.method = method;
    config.url = url;
    config.data = data;

    return instance.request(config);
}

axios.postCsrf = function(url, data, config) {
    return axios.requestCsrf('POST', url, data, config);
}

axios.deleteCsrf = function(url, data, config) {
    return axios.requestCsrf('DELETE', url, data, config);
}

axios.putCsrf = function(url, data, config) {
    return axios.requestCsrf('PUT', url, data, config);
}

export default axios;
